<template>
  <v-main align="center">
    <v-container class="fill-height" fluid v-if="hasCompany && !status.loading">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="10">
          <v-card class="elevation-12">
            <ReportToolbar />
            <router-view></router-view>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import store from "@/stores/store";
import i18n from "@/languages";
import ReportToolbar from "@/components/report/ReportToolbar";

export default {
  name: "Report",
  computed: {
    ...mapState("users", [
      "status",
      "currentUser",
      "userCompany",
      "hasCompany",
    ]),
  },
  methods: {
    ...mapActions("users", ["getUserCompany"]),
  },
  created() {
    if (!this.hasCompany) {
      this.$router.push("/company/create");
      store.dispatch(
        "alert/error",
        i18n.t("application.noCompanyError", { root: true })
      );
    }
  },
  components: {
    ReportToolbar,
  },
};
</script>

<style>
</style>